import PageHeader from "@/components/site/PageHeader";
import { usePosts } from "@/lib/posts";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useSEO } from "@/lib/seo";

export default function Nyheter() {
    const posts = usePosts();
    useSEO({
        title: "Nyheter",
        description:
            "Aktuella artiklar om affärsjuridik, fastighetsrätt, familjerätt, arbetsrätt och brottmål — skrivna av BM Juridiks jurister.",
    });
    return (
        <div data-testid="page-nyheter">
            <PageHeader
                kicker="Nyheter"
                title="Insikter, analyser och"
                accent="perspektiv."
                description="Vi delar löpande artiklar om aktuella frågor inom våra rättsområden — skrivna av byråns jurister för dig som vill ligga steget före."
            />

            <section className="py-20 bg-[#0A0A0B]">
                <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
                    {posts.map((p, i) => (
                        <motion.article
                            key={p.slug}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                        >
                            <Link
                                to={`/nyheter/${p.slug}`}
                                data-testid={`news-item-${p.slug}`}
                                className="group block bg-[#111113] border border-white/5 hover:border-[#C4A977]/40 p-10 rounded-sm transition-colors duration-500"
                            >
                                <div className="flex flex-col sm:flex-row sm:items-center gap-3 text-xs text-[#A1A1AA] uppercase tracking-widest">
                                    <span className="text-[#C4A977]">
                                        {p.category}
                                    </span>
                                    <span className="hidden sm:block w-1 h-1 bg-white/20 rounded-full" />
                                    <span>{p.date}</span>
                                </div>
                                <h2 className="mt-5 font-serif text-3xl lg:text-4xl text-[#F4F4F5] group-hover:text-[#C4A977] leading-tight transition-colors duration-500">
                                    {p.title}
                                </h2>
                                <p className="mt-5 text-[#A1A1AA] leading-relaxed max-w-3xl">
                                    {p.excerpt}
                                </p>
                                <div className="mt-6 inline-flex items-center gap-2 text-sm text-[#C4A977]">
                                    Läs artikel
                                    <ArrowRight
                                        size={14}
                                        className="transition-transform duration-300 group-hover:translate-x-1"
                                    />
                                </div>
                            </Link>
                        </motion.article>
                    ))}
                </div>
            </section>
        </div>
    );
}
